import { render, staticRenderFns } from "./homeDashboardContractTerminationsDialog.vue?vue&type=template&id=afeebb88&scoped=true"
import script from "./homeDashboardContractTerminationsDialog.vue?vue&type=script&lang=js"
export * from "./homeDashboardContractTerminationsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeebb88",
  null
  
)

export default component.exports